"use strict";
import Api from "../api/api";
export default {
  quickpayPercentage(carrier) {
    if (_.isEmpty(carrier.quickpayDiscount)) {
      return Api.Account.currentSettings()["quickpayDiscount"];
    } else {
      return parseFloat(carrier.quickpayDiscount);
    }
  },
  quickpayMinimum() {
    return Api.Account.currentSettings()["quickpay_minimum"];
  },
  hasQuickpayAdjustment(invoice, carrier) {
    return invoice.quickpay && this.quickpayPercentage(carrier);
  },
  quickpayDiscountAmount: function(total, carrier) {
    var discountAmount = 0;
    if (total > 0) {
      discountAmount = this.quickpayPercentage(carrier) * total / 100;
      if (this.quickpayMinimum() > discountAmount) {
        discountAmount = this.quickpayMinimum();
        if (discountAmount > total) {
          discountAmount = total;
        }
      }
    }
    return discountAmount;
  },
  quickpayDiscountAmountUsed(totalFromCarrierInvoice, carrier) {
    var amountUsed = "";
    var total = totalFromCarrierInvoice;
    if (total > 0) {
      amountUsed = this.quickpayPercentage(carrier) + "%";
      var discountAmount = this.quickpayPercentage(carrier) * total / 100;
      if (this.quickpayMinimum() > discountAmount) {
        if (this.quickpayMinimum() > total) {
          discountAmount = total;
        }
        amountUsed = "$" + discountAmount + " Minimum";
      }
    }
    return amountUsed;
  }
};
